module.exports = __webpack_public_path__ + "img/csr_swiper_04_09.f933df08.jpg";